import React from 'react';

function PlayAllButton() {
  return (
    <div  id="playAllButton" className="h-10">
      <button
        className="px-6 py-3 text-sm font-light rounded-full flex items-center bg-yellow-800 text-white hover:bg-yellow-700 transition duration-300 ease-in-out"

        tabIndex="0"
        style={{ opacity: 1, willChange: 'auto', transform: 'none' }}
      >
        <div className="mr-3">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="circle-play"
            className="svg-inline--fa fa-circle-play"
            role="img"
            
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
            />
          </svg>
        </div>
        <div>PLAY ALL</div>
      </button>
    </div>
  );
}

export default PlayAllButton;
